---
de:
  power_plants:
    asset_class_types:
      all: ALLE
      bilateral/asset: Bilateral
      hydro/asset: Hydro
      solar/asset: Solar
      wind/asset: Wind
    bell:
      link_ok: Verbindung OK
      no_link: Keine Verbindung
    bilateral_capacity_hint: Installierte Kapazität für dieses bilaterale Kraftwerk
    capacity_hint: Aus Produktionseinheiten
    change_selection: Ändere die Kraftwerkeauswahl
    chart_load:
      categories:
      - Keine Produktion
      - L (25%)
      - M (25% - 75%)
      - H (> 75%)
      last_month: Letzter Monat
      subtitle: "% der Zeit, stündlich"
      this_month: Dieser Monat
      title: Last
    chart_meteogram_title: 48-Stunden Vorhersage
    commercial_details: Kommerzielle Details
    commissioning_date_hint: Erster Betriebstag
    deviation: Abweichung
    edit_heading: Bearbeite Kraftwerksinformationen
    edit_notice: CKontaktieren Sie das Personal, wenn beschränkte Felder geändert werden müssen
    effect_hint: Aus Produktionseinheiten
    elcert_count: Anzahl ElCerts
    environmental_flow_breakpoints: Umweltabfluss
    errors:
      different_source: Muss sich von der festgelegten Quellenangabe unterscheiden
      missing_attribute: Fehlendes %{attribute}
      shadow_excludes_unscaled_contract: kann nicht aktiviert werden, solange ein Einspeisetarif- oder Hedging-Vertrag verknüpft ist, da diese Verträge keinen Eigentumsanteil zur Aufteilung der gemeinsamen Produktion haben
      shadow_requires_canonical: muss mit dem Messpunkt eines vorhandenen Nicht-Schatten-Kraftwerks übereinstimmen
    est_downtime_cost: Schätzungskosten für Ausfallzeiten
    est_production: Geschätzte Produktion
    est_tech_downtime: Geschätzte technische Ausfallzeit
    export_xlsx: In Excel exportieren
    financial_settlement: Finanzielle Abgeltung
    generator: Generator
    go_count: Anzahl HKN
    intake: Fassung
    intakes: Fassungen
    kpi_monthly: Monatliche Performance
    measure_theor_production: Übersicht - gemessene vs. prognostizierte Produktion
    measured_power: Gemessene Leistung
    model_params:
      empty: Keine Modellparameter verfügbar.
      nve_fallback_hint: NVE-Wert wird verwendet (durch Eingabe eines Werts überschreiben)
      production_min_runtime_hours_hint: Wird nur von deterministic_2step verwendet. Leer = API-Standard von 24 h. Muss in den Optimierungshorizont passen (Perioden × Segmente, standardmäßig 168 h), sonst wird das Minimum aus dem Stillstand nie angefahren.
      startup_override_placeholder: Produktionswerte eingeben
    monthly_production: Monatsübersicht - gemessene vs. prognostizierte Produktion
    nve_info: NVE-Info
    of_ytd_avg: von YTD Durchschnitt
    of_ytd_budget: von YTD Budget
    penstock: Druckleitung
    power_curve: Leistungskurve
    power_plant_age: Alter des Kraftwerks
    precipitation_field: Niederschlagsfeld
    price_prod_history: Preis- und Produktionshistorie
    prod_bud_by_month: Produktion vs. Budget pro Monat
    prod_by_month: Produktion pro Monat
    prod_sales_data: Produktions- und Verkaufszahlen
    reservoir: Stausee
    rev_bud_by_month: Umsatz vs. Budget pro Monat
    rev_by_month: Umsatz pro Monat
    river: Fluss
    runoff_avg: Durchschnittliche Abflussmenge
    runoff_ytd: Abfluss YTD
    select_day: Wählen Sie den Tag des Monats
    select_month: Wählen Sie den Monat
    shadow_source_hint: Kopiert die Messstellen-ID der ausgewählten Anlage in das obige Feld
    shadow_source_label: Messpunkt von Anlage kopieren
    solar_inverter_production: Normierter Tagesertrag Wechselrichter [kWh/kWp]
    solar_kpi_epi: Energy Performance Index
    solar_kpi_pr: Performance Ratio
    solar_kpi_system_losses: Systemverluste
    spider_categories:
    - Volllaststunden (%)
    - Realisierter Preis vs. Spotpreis
    - Betriebsstunden insgesamt
    - Betriebsstunden nachts
    - Theoretische Produktion vs. Normale Produktion
    - Abfluss vs. Normal
    spot_price: Spot Preis
    spot_revenue: Spot Umsazt
    starts_stops: Starts/Stops
    substation: Untersation
    supplier_add: Lieferant hinzufügen
    supplier_form_title: Leiferanten
    theoretical_power: Theoretische Leistung
    tooltips:
      continuous_forecast_enabled: Übermittelt die Day-Ahead-Produktionsprognose erneut, sobald neue Wetterdaten von Meteomatics eintreffen (Wind-/Solaranlagen).<br>Erfordert Forecast Query und Day-Ahead-Prognose.
      day_ahead_forecast_enabled: Übermittelt die Day-Ahead-Produktionsprognose (15-Minuten-Auflösung) an Kaia Trade für Wind-/Solaranlagen stündlich von 07:20 bis 11:20.<br>Erfordert Forecast Query.
      forecast_query_enabled: Hauptschalter für ausgehende Übermittlungen an Kaia Trade.<br>Wenn aktiviert, sendet der stündliche Job von 07:20 bis 11:20 (und der kontinuierliche Wetter-Poller) das, was die Schalter darunter aktivieren&#58; Produktionspläne, Day-Ahead-Prognosen und preisabhängige Gebote.<br>Deaktivieren stoppt alle Übermittlungen für diese Anlage.
      production_simulation_plan_enabled: Führt die Produktionssimulation stündlich von 07:10 bis 11:10 lokal aus und speichert den resultierenden Plan.<br>Der Plan wird dann vom zugehörigen Job von 07:20 bis 11:20 an Kaia Trade übermittelt — diese Übermittlung erfordert zusätzlich Forecast Query, eine Kaia UUID und deaktiviertes Shadow-Testing.<br>Zurückgegebene Akzeptiert/Abgelehnt-Statusangaben werden für jedes Planelement gespeichert.
      shadow_testing: Schattentestmodus — fragt die Produktionsplanungs-API ab, sendet aber nichts an Trade (Kaia).<br>Verwenden Sie dies, um die Produktionsplanung zu testen, ohne Marktübermittlungen zu beeinflussen.
      use_price_dependent_bid: Übermittelt eine preisabhängige Gebotskurve an Kaia Trade stündlich von 07:20 bis 11:20, basierend auf Marktpreisen und Anlagenökonomie.<br>Erfordert Forecast Query und einen Market Parameter mit aktivierter Gebotsfunktion für diese Anlage.
    tot_power_rev: Gesamt-Stromumsätze
    total_hours: Gesamtstunden
    total_revenue: Gesamtumsätze
    total_sales: Gesamtverkäufe
    transformer: Transformator
    turbine: Turbine
    turbine_types:
      bulb: Bulb
      francis: Francis
      kaplan: Kaplan
      lawaczeck: Lawaczeck
      ossberger: Ossberger
      pelton: Pelton
      pump: Pump
      turgo: Turgo
    unconfirmed: Geschätzte / unbestätigte Zahlen
    water_icon:
      alert: Alarm beim Wasserstand
      normal: Normaler Wasserstand
      overflow: Überlauf
      underflow: Unterspülung
      update: Keine aktuelle Datei
    wind_kpi_eb_availability: Energiebasierte Verfügbarkeit
    wind_kpi_eb_losses: Energieverluste
    wind_rose: Windrose
